// Global Instructions Rule Applied!

import React, { forwardRef } from 'react'
import { Input } from 'antd'
import { InputSize, FieldValue, textFieldValue } from '../types.ts'

const { TextArea } = Input

export interface TextareaInputProps {
  value: FieldValue
  onChange: (value: string) => void
  onKeyDown?: (e: React.KeyboardEvent) => void
  size?: InputSize
  status?: 'error' | 'warning'
  placeholder?: string
  rows?: number
  maxLength?: number
  autoSize?: boolean | { minRows: number; maxRows: number }
  autoFocus?: boolean
}

export const TextareaInput = forwardRef<HTMLTextAreaElement, TextareaInputProps>(
  (
    { value, onChange, onKeyDown, size = 'small', status, placeholder, rows = 15, maxLength, autoSize, autoFocus },
    ref
  ) => {
    return (
      <TextArea
        ref={ref}
        value={textFieldValue(value)}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        size={size}
        status={status}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        autoSize={autoSize}
        style={{ width: '100%' }}
        autoFocus={autoFocus}
      />
    )
  }
)

TextareaInput.displayName = 'TextareaInput'
